
import tagableMixin from "~/mixins/tagableMixin";

const DIMENSION = "73";

export default {
  mixins: [tagableMixin],

  props: { product: { type: Object, default: () => {} } },

  computed: {
    tags() {
      return this.product.tags ?? [];
    },
    imageOptions() {
      const image = this.selectedVariant?.images[0];

      return {
        src: image?.w_73_h_73_webp ?? image?.src ?? "",
        alt: this.product.title,
        widths: [DIMENSION],
        width: DIMENSION,
        height: DIMENSION,
      };
    },
    selectedVariant() {
      return this.product.selectedVariant;
    },
  },
};
